
import { supabase } from '@/integrations/supabase/client';
import { ApiProvider } from '@/hooks/useApiProviders';

/**
 * Ensure the 24Seven Office provider is properly configured in the database
 */
export async function ensure24SevenProvider(): Promise<ApiProvider> {
  // Check if 24Seven provider exists
  const { data, error } = await supabase
    .from('api_providers')
    .select('*')
    .eq('code', '24seven')
    .maybeSingle();
    
  if (error) {
    throw error;
  }
  
  // Provider configuration
  const provider24Seven = {
    name: '24Seven Office',
    code: '24seven',
    base_url: 'https://webapi.24sevenoffice.com',
    auth_type: 'custom_token' as const,
    auth_url: 'https://id.24sevenoffice.com/Authentication/Login/Login',
    token_url: 'https://api.24sevenoffice.com/Authentication/V001/authenticate/apikey',
    logo_url: 'https://24sevenoffice.com/wp-content/themes/24sevenoffice/img/logo.svg',
    is_active: true,
  };
  
  // If provider doesn't exist, create it
  if (!data) {
    const { data: newProvider, error: insertError } = await supabase
      .from('api_providers')
      .insert(provider24Seven)
      .select()
      .single();
      
    if (insertError) {
      throw insertError;
    }
    
    return {
      ...newProvider,
      auth_type: newProvider.auth_type as 'oauth2' | 'api_key' | 'custom_token'
    };
  }
  
  // If provider exists but needs updating
  if (
    data.base_url !== provider24Seven.base_url ||
    data.auth_url !== provider24Seven.auth_url ||
    data.token_url !== provider24Seven.token_url
  ) {
    const { data: updatedProvider, error: updateError } = await supabase
      .from('api_providers')
      .update(provider24Seven)
      .eq('id', data.id)
      .select()
      .single();
      
    if (updateError) {
      throw updateError;
    }
    
    return {
      ...updatedProvider,
      auth_type: updatedProvider.auth_type as 'oauth2' | 'api_key' | 'custom_token'
    };
  }
  
  // Return existing provider
  return {
    ...data,
    auth_type: data.auth_type as 'oauth2' | 'api_key' | 'custom_token'
  };
}
